module.exports = __webpack_public_path__ + "img/logo-7203.72a4c8f9.png";